import { theme, $fontOpenSans } from '../../styles/theme';
import { alpha } from '@mui/material';
export const statusBadgeCertified = {
    padding: '8px',
    border: `1px solid ${theme.palette.common.feedbackSuccess50}`,
    background: theme.palette.common.feedbackSuccess10,
    color: theme.palette.common.darkGrey2,
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '32px',
    width: 'fit-content',
    fontFamily: $fontOpenSans,
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '> img': {
        marginRight: '5px'
    }
};
export const statusBadgePendingCertification = {
    ...statusBadgeCertified,
    background: 'rgba(145, 145, 145, 0.05)',
    border: `1px solid ${alpha(theme.palette.common.darkRed, 0.05)}`
};
export const statusBadgeUncertified = {
    ...statusBadgeCertified,
    background: theme.palette.common.lightPink3,
    border: `1px solid ${theme.palette.common.lightRed2}`,
    fontWeight: 600
};
export const statusBadgeSpeakingUnscorable = {
    ...statusBadgeCertified,
    background: 'rgba(211, 0, 24, 0.70)',
    border: '1px solid #FFD5BD',
    color: theme.palette.common.lightGrey6
};
export const statusBadgeInProgress = {
    ...statusBadgeCertified,
    background: 'rgba(255, 187, 28, 0.1)',
    border: '1px solid #FFECBF',
    color: theme.palette.common.darkGrey3
};
export const statusBadgeCompleted = {
    ...statusBadgeCertified,
    background: theme.palette.common.lightGrey4,
    border: `1px solid ${theme.palette.common.lightGrey14}`
};
export const statusBadgeError = {
    ...statusBadgeCertified,
    background: alpha(theme.palette.common.darkRed, 0.7),
    border: '1px solid #D4EADD',
    color: theme.palette.common.lightGrey6
};
export const statusBadgeAppealed = {
    ...statusBadgeCertified,
    background: theme.palette.common.darkBlue2,
    color: theme.palette.common.white,
    border: 'none'
};
export const statusBadgeLateHangup = {
    ...statusBadgeCertified,
    background: theme.palette.common.darkGrey8,
    color: theme.palette.common.lightGrey6,
    border: 'none'
};
export const statusBadgeStarted = {
    ...statusBadgeCertified,
    background: theme.palette.common.white,
    color: theme.palette.common.darkBlue7,
    border: '1px solid #C9E2E9',
    '> img': {
        width: '15px',
        height: 'auto',
        marginRight: '3px'
    }
};
export const statusBadgeNotStarted = {
    ...statusBadgeCertified,
    background: theme.palette.common.feedbackInfo10,
    border: `1px solid ${theme.palette.common.feedbackInfo50}`
};
export const statusBadgeActionRequired = {
    ...statusBadgeCertified,
    background: 'var(--color-feedback-warning-10)',
    border: `1px solid ${theme.palette.common.feedbackWarning50}`
};
export const statusBadgeExpired = {
    ...statusBadgeCertified,
    background: theme.palette.common.white,
    color: theme.palette.common.darkGrey2,
    border: `1px solid ${theme.palette.common.darkGrey0}`
};
//# sourceMappingURL=StatusBadge.styles.js.map